import { defineMasterdataEntity } from '../types/masterdata-entity-definition';
import { MasterdataProductionSite } from '../types/masterdata-entities';
import { keyName } from './shared';

export const MASTERDATA_PRODUCTION_SITE =
  defineMasterdataEntity<MasterdataProductionSite>({
    name: 'production-site',
    responseKey: 'productionSites',
    displayWith: (s) => keyName(s.key, s.name),
    secondaryWith: (s) => s.description1,
    icon: 'fa-regular fa-industry',
    title: 'Betriebssuche',
    label: 'Betrieb',
    placeholder: 'Betrieb suchen...',
    columns: [
      {
        label: 'Betrieb',
        type: 'entity',
        icon: 'fa-regular fa-industry',
        value: (e) => keyName(e.key, e.name),
        secondary: (e) => e.description1,
      },
      { label: 'Schlüssel', type: 'text', value: (e) => e.key },
      { label: 'Bezeichnung', type: 'text', value: (e) => e.name },
      {
        label: 'Registriernummer',
        type: 'text',
        value: (e) => e.registrationNumber,
      },
      { label: 'Beschreibung', type: 'text', value: (e) => e.description1 },
      { label: 'Beschreibung 2', type: 'text', value: (e) => e.description2 },
      { label: 'Beschreibung 3', type: 'text', value: (e) => e.description3 },
    ],
  });
